import { Download, FileText } from 'lucide-react'

/**
 * Monthly report card mockup. Mirrors the GenerateReportCard on the
 * Dashboard tab — quota pill, month chips, big "Generate" CTA, plus
 * a thumbnail preview of the PDF output as a visual proof point.
 */
export function ReportMockup() {
  return (
    <div className="grid gap-5 p-6 sm:grid-cols-[1fr_1fr]">
      {/* Generator card */}
      <div className="rounded-xl border border-border bg-bg/40 p-4">
        <div className="flex items-center justify-between">
          <p className="font-display text-[10px] font-bold tracking-[0.2em] text-fg-subtle uppercase">
            Monthly report
          </p>
          <span className="font-display rounded-full border border-primary/40 bg-primary/10 px-2 py-0.5 text-[10px] font-bold tracking-[0.15em] text-primary uppercase">
            1 / 2 used
          </span>
        </div>
        <div className="mt-3 flex gap-1.5">
          <button
            type="button"
            className="font-display flex-1 rounded-md border border-primary/40 bg-primary/10 px-2 py-1.5 text-[11px] font-bold tracking-[0.12em] text-primary uppercase"
          >
            June
          </button>
          <button
            type="button"
            className="font-display flex-1 rounded-md border border-border bg-bg/40 px-2 py-1.5 text-[11px] font-bold tracking-[0.12em] text-fg-muted uppercase"
          >
            May
          </button>
        </div>
        <button
          type="button"
          className="font-display mt-4 inline-flex w-full items-center justify-center gap-1.5 rounded-md border border-primary/40 bg-primary/15 px-3 py-2.5 text-xs font-bold tracking-[0.12em] text-primary uppercase"
        >
          <Download className="size-3.5" aria-hidden />
          Generate PDF
        </button>
      </div>

      {/* PDF thumbnail */}
      <div className="relative rounded-xl border border-border bg-white p-4 text-black shadow-lg">
        <div className="flex items-center gap-2 border-b border-black/10 pb-2">
          <FileText className="size-3 text-black/60" aria-hidden />
          <span className="font-display text-[9px] font-bold tracking-[0.15em] text-black/60 uppercase">
            BLACKLINE · JUNE 2026
          </span>
        </div>
        <div className="mt-3 space-y-2">
          <div className="space-y-1">
            <div className="h-1.5 w-3/4 rounded bg-black/80" />
            <div className="h-1 w-full rounded bg-black/20" />
            <div className="h-1 w-5/6 rounded bg-black/20" />
          </div>
          <div className="mt-3 grid grid-cols-3 gap-1.5">
            <div className="rounded border border-black/10 p-1.5 text-center">
              <p className="text-[7px] font-bold tracking-wider text-black/60">MEMBERS</p>
              <p className="text-sm font-black text-black">47</p>
            </div>
            <div className="rounded border border-black/10 p-1.5 text-center">
              <p className="text-[7px] font-bold tracking-wider text-black/60">EVENTS</p>
              <p className="text-sm font-black text-black">12</p>
            </div>
            <div className="rounded border border-black/10 p-1.5 text-center">
              <p className="text-[7px] font-bold tracking-wider text-black/60">REVENUE</p>
              <p className="text-sm font-black text-black">£612</p>
            </div>
          </div>
          <div className="mt-2 space-y-1">
            <div className="h-1 w-full rounded bg-black/15" />
            <div className="h-1 w-11/12 rounded bg-black/15" />
            <div className="h-1 w-4/5 rounded bg-black/15" />
            <div className="h-1 w-3/4 rounded bg-black/15" />
          </div>
        </div>
      </div>
    </div>
  )
}
